import HelpIcon from '@material-ui/icons/Help';
import StoreIcon from '@material-ui/icons/Store';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ChatIcon from '@material-ui/icons/ChatOutlined';
import DashboardIcon from '@material-ui/icons/Dashboard';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import FormatListBulletedIcon from '@material-ui/icons/ImportContacts';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import StorefrontTwoToneIcon from '@material-ui/icons/StorefrontTwoTone';
import WorkOffIcon from '@material-ui/icons/WorkOff';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import StoreOutlinedIcon from '@material-ui/icons/StoreOutlined';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import AssignmentReturnOutlinedIcon from '@material-ui/icons/AssignmentReturnOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import WorkIcon from '@material-ui/icons/Work';
import BuildIcon from '@material-ui/icons/Build';
import LiveHelp from '@material-ui/icons/LiveHelp';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ListIcon from '@material-ui/icons/List';
import ViewCompactIcon from '@material-ui/icons/ViewCompact';
import ViewWeekIcon from '@material-ui/icons/ViewWeek';

const icons = {
    HelpIcon,
    StoreIcon,
    VisibilityIcon,
    ChatIcon,
    DashboardIcon,
    CreditCardIcon,
    FormatListBulletedIcon,
    PersonIcon,
    ShoppingCartIcon,
    StorefrontTwoToneIcon,
    WorkOffIcon,
    AirportShuttleIcon,
    AssessmentOutlinedIcon,
    WorkOffIcon,
    AssessmentOutlinedIcon,
    AddBoxOutlinedIcon,
    StoreOutlinedIcon,
    AssignmentReturnOutlinedIcon,
    PersonOutlineOutlinedIcon,
    WorkIcon,
    AssignmentIcon,
    PersonAddOutlinedIcon,
    BuildIcon,
    LiveHelp,
    AssignmentIndIcon,
    AccountCircleIcon,
    ListIcon,
    ViewCompactIcon,
    ViewWeekIcon,
};

export default icons;
